const language = {
    ENGLISH: 1,
    GERMAN: 2,
    SPANISH: 3,
    ITALIAN: 4,
    PORTUGUESE: 5,
    SWEDISH: 6,
    SWISS_ITALIAN: 8,
    SWISS_FRENCH: 9,
    CANADIAN_FRENCH: 10,
    SWISS_GERMAN: 16,
};

const iso = {
    AUSTRALIAN_ENGLISH: "en-AU",
    ENGLISH: "en",
    CANADIAN_FRENCH: "fr-CA",
    CANADIAN_ENGLISH: "en-CA",
    GERMAN: "de",
    ITALIAN: "it",
    JAPANESE: "ja",
    INDIAN_ENGLISH: "en-IN",
    NEW_ZEALAND_ENGLISH: "en-NZ",
    PORTUGUESE: "pt",
    SPANISH: "es",
    SOUTH_AFRICAN_ENGLISH: "en-ZA",
    SWEDISH: "sv-SE",
    SWISS_FRENCH: "fr-CH",
    SWISS_GERMAN: "de-CH",
    SWISS_ITALIAN: "it-CH",
};

export default { language, iso };
